import {
  apiClient,
  ApiClientConfig,
  PaginatedRequestParams,
  PaginatedResponse,
} from 'api';
import { AxiosResponse } from 'axios';
import {  User } from 'types';
import { Matrial } from 'types/matrial';

type userMenu = {
  id: string;
  menu: string;
  isPermission: boolean;
}
export interface GetUserListResponse extends User {
  "Menu": userMenu[]
}

 interface BaseResponse<T> {
  rs: number;
  res?: T;
  rc?: any[]; // if this is always an array, or refine as needed
  msgkey?: string | null;
  ukey?: string;
  customMessage?: string;
  itemId?: number;
  totalRecords?: number;
}

export interface UserListParams extends PaginatedRequestParams {
  full_user_name?: string;
  phone_number?: string;
  roles?: string[];
  company_id?: string;
  created_at_from?: string; // ISO8601_FORMAT
  created_at_to?: string; // ISO8601_FORMAT
}
export type CreateMasterDTO = {
  flag: string;
  title?: string | null;
  description?: string;  
  type:number ;
  isActive: boolean;
};

export type UpdateUserRoleDTO = {
  user_id: string | undefined;
  MenuIds: string[];
}

export type UpdateUserDTO = {
  userId: string;
  email?: string | null;
  name?: string;  
  password?: string;
  phoneNumber?: string;
  isActive?: boolean;
  roleType?: number; 
};

export type SupplierResponse = BaseResponse<PaginatedResponse<User>>;


export type WeightBridgeList = {
  Id:number,
  Title:string,
  IsDefault:boolean
}

export type WeightBridgeListResponse = BaseResponse<WeightBridgeList> ;

export const MatsterApiService = () => {
  const createMaterial = async (
    payload: CreateMasterDTO,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<BaseResponse<Matrial>>({
      ...callConfig,
      endpoint: `/Masters/AddOrUpdateMaterials`,
      method: 'POST',
      data: payload,
    });
    
    return response?.data;
  };
  const createStation = async (
    payload: CreateMasterDTO,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<BaseResponse<Matrial>>({
      ...callConfig,
      endpoint: `/Masters/AddOrUpdateStation`,
      method: 'POST',
      data: payload,
    });
    
    return response?.data;
  };
   const createSupplier = async (
    payload: CreateMasterDTO,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<BaseResponse<Matrial>>({
      ...callConfig,
      endpoint: `/Masters/UpsertSupplier`,
      method: 'POST',
      data: payload,
    });
    
    return response?.data;
  };
  const getMatrial = async (id: string, callConfig?: Partial<ApiClientConfig>): Promise<BaseResponse<User>> => {
    const response: AxiosResponse<BaseResponse<User>> = await apiClient<BaseResponse<User>>({
      ...callConfig,
      endpoint: `/Admin/GetUser/${id}`,
    });
        
    return {
      res: response.data.res,
      rs: response.status,
    };
  };

  const getMatrials = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<SupplierResponse>({
      ...callConfig,
      endpoint: `Masters/GetAllMaterials`,
      params,
    });
       
    
    return response.data;
  };
  const getSuppliers = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<SupplierResponse>({
      ...callConfig,
      endpoint: `Masters/GetAllSuppliers`,
      params,
    });
       
    return response.data;
  };
   const gettype = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<SupplierResponse>({
      ...callConfig,
      endpoint: `Masters/GetAllMaterialTypes`,
      params,
    });
       
    return response.data;
  };
  const updateMatrial = async (
    payload: UpdateUserDTO,
    callConfig?: Partial<ApiClientConfig>,
  ) => {  
    //const { userId, ...data } = payload;
    const data = payload ;
    const response = await apiClient<BaseResponse<User>>({
      ...callConfig,
      endpoint: `/Admin/UpdateUser`,
      method: 'PATCH',
      data,
    });
    
    return response.data.rs;
  };
 const getSatationtype = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<SupplierResponse>({
      ...callConfig,
      endpoint: `Masters/GetAllStationTypes`,
      params,
    });
       
    return response.data;
  };
   const getStation = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<SupplierResponse>({
      ...callConfig,
      endpoint: `Masters/GetAllStations`,
      params,
    });
       
    return response.data;
  };
   const createWeighbride = async (
    payload: CreateMasterDTO,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<BaseResponse<Matrial>>({
      ...callConfig,
      endpoint: `/AdminWeighbridge/SetDefaultWeighBridge`,
      method: 'POST',
      data: payload,
    });
    
    return response?.data;
  };

  const getWeightBridge = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<WeightBridgeListResponse>({
      ...callConfig,
      endpoint: `AdminWeighbridge/GetWeightBridge`,
      params,
    });
       
    return response.data;
  };

  return {
    createMaterial,
    getMatrial,
    getMatrials,
    getStation,
    updateMatrial,
    getSuppliers,
    gettype,
    createSupplier,
    createStation,
    getSatationtype,
    createWeighbride,
    getWeightBridge
  };
};
